module.exports = __webpack_public_path__ + "static/media/down.e70c80e4.svg";